<template>
    <div id='privacyPolicy'>
        <!------------------------------隱私協議開始------------------------------>
        <section class="cm-privacyPolicy-section">
            <div class="container-fluid p-0">
                <div class="row no-gutters">
                    <div class="col">
                        <img class="img-fluid" :src=imageUrl>
                    </div>
                </div>
            </div>


            <div class="d-flex align-items-start justify-content-center mb-4 cm-triangle">
                <div class="cm-triangle-font">
                    {{$t('footer.PrivacyPolicy.Title')}}
                </div>
            </div>


            <div class="cm-privacyPolicy-content" v-html="this.$i18n.t('footer.PrivacyPolicy.Content')"></div>
            <div class="cm-privacyPolicy-banner-line"></div>
        </section>
        <!------------------------------隱私協議結束------------------------------>
    </div>
</template>

<script>
import * as BackendSetting from "@/assets/js/util/BackendSetting.js";
import eventBus from '@/assets/js/event/EventBus.js'
export default {
    data() {
        return {
            imageUrlDefault: require("@/assets/images/game/gametitle.jpg"),
            imageUrl: require("@/assets/images/game/gametitle.jpg")
        }
    },
    mounted() {
        this.updateTopBackgroundImg();
        document.documentElement.scrollTop = 0;
        
        // 更換語言時
        const self = this;
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_PRIVACY_POLICY, function(i18n) {
            self.updateTopBackgroundImg(i18n);
        })
    },
    methods: {
        async updateTopBackgroundImg(i18n = this.$i18n) {
            // 更新上方背景圖
            let imageUrl = await BackendSetting.getTopBackgroundImgUrl(i18n.locale);
            this.imageUrl = (imageUrl != "" ? imageUrl : this.imageUrlDefault);
        }
    }
}
</script>